export default __webpack_public_path__ + "static/media/JerseyDark.ad745c47.svg";